<section class="bg-servios padding-70px-tb xs-padding-60px-tb" id="video-section7">
    <div class="container">
        <!-- <div class="row">
            <div class="col-lg-8 col-md-10 col-sm-12 col-12 text-center center-col">
                <h2
                    class="section-title-large sm-section-title-medium xs-section-title-large text-white font-weight-600 alt-font margin-six-bottom xs-margin-fifteen-bottom">
                    WE'RE SMALL BUT IMPRESSIVE.</h2>
                <div
                    class="text-medium width-90 margin-lr-auto md-width-70 sm-width-100 text-white margin-thirteen-bottom xs-margin-nineteen-bottom">
                    Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the
                    industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type
                    and scrambled it to make a type specimen book.
                </div>
            </div>
        </div> -->
        <div class="row">
            <div class="col-md-12 col-sm-12 col-12 display-table position-relative">
                <div id="counter">
                    <div class="row">
                        <div class="col-md-3 col-sm-6 col-6 sm-margin-fifteen-bottom xs-margin-seventeen-bottom text-center 
                        wow animated slideInDown">
                            <div class="counter-content">
                                <i
                                    class="fas fa-briefcase icon-large text-white margin-fifteen-bottom sm-margin-fifteen-bottom xs-margin-seven-bottom"></i>
                                <span
                                    class="timer counter-number title-extra-large text-white sm-title-extra-large-1 alt-font margin-three-bottom xs-margin-one-half-bottom display-block font-weight-600 appear"
                                    data-to="200" data-speed="1000">200</span>
                                <span class="text-medium sm-text-medium display-block text-white">Proyectos
                                    Realizados</span>
                                <div class="separator-line3 bg-white center-col margin-fifteen-top sm-margin-ten-top">
                                </div>
                            </div>
                        </div>
                        <div
                            class="col-md-3 col-sm-6 col-6 sm-margin-fifteen-bottom xs-margin-seventeen-bottom text-center  wow animated slideInDown">
                            <div class="counter-content">
                                <i
                                    class="far fa-heart icon-large text-white margin-fifteen-bottom sm-margin-fifteen-bottom xs-margin-seven-bottom"></i>
                                <span
                                    class="timer counter-number title-extra-large sm-title-extra-large-1 alt-font text-white margin-three-bottom xs-margin-one-half-bottom display-block font-weight-600 appear"
                                    data-to="100" data-speed="1000">100</span>
                                <span class="text-medium sm-text-medium display-block text-white">Clientes
                                    satisfechos</span>
                                <div class="separator-line3 bg-white center-col margin-fifteen-top sm-margin-ten-top">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-6 col-6 xs-no-margin-bottom text-center  wow animated slideInDown">
                            <div class="counter-content">
                                <i
                                    class="fas fa-home icon-large text-white margin-fifteen-bottom sm-margin-fifteen-bottom xs-margin-seven-bottom">
                                </i>
                                <span
                                    class="timer counter-number title-extra-large sm-title-extra-large-1 alt-font text-white margin-three-bottom xs-margin-one-half-bottom display-block font-weight-600 appear"
                                    data-to="9" data-speed="1000">9</span>
                                <span class="text-medium sm-text-medium display-block text-white">Tipod de
                                    servicios</span>
                                <div class="separator-line3 bg-white center-col margin-fifteen-top sm-margin-ten-top">
                                </div>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-6 col-6 xs-no-margin-bottom text-center  wow animated slideInDown">
                            <div class="counter-content">
                                <i
                                    class="far fa-clock icon-large text-white margin-fifteen-bottom sm-margin-fifteen-bottom xs-margin-seven-bottom"></i>
                                <span
                                    class="timer counter-number title-extra-large sm-title-extra-large-1 alt-font text-white margin-three-bottom xs-margin-one-half-bottom display-block font-weight-600 appear"
                                    data-to="500" data-speed="1000">500</span>
                                <span class="text-medium sm-text-medium display-block text-white">Horas de
                                    experiencia</span>
                                <div class="separator-line3 bg-white center-col margin-fifteen-top sm-margin-ten-top">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>